module.exports = __webpack_public_path__ + "static/media/Arrow.e1a382a1.png";